import React from 'react'
import Alert from '@mui/material/Alert'
import strings from 'strings'

const FM = strings.FLEET_MONITORING

// Shared clarification shown at the top of both the Fleets and Alert Settings tabs: explains the
// company-default → per-fleet override (Inherit/On/Off) cascade and how owners/recipients are set
// at each level. Stateless and identical in both places so users build one mental model.
const OverrideInfoNote: React.FunctionComponent = () => (
  <Alert
    severity="info"
    role="note"
    data-testid="fleet-monitoring-override-note"
    sx={{ marginBottom: '1rem', alignItems: 'flex-start' }}
  >
    <strong>{FM.COMMON.OVERRIDE_NOTE_TITLE}.</strong> {FM.COMMON.OVERRIDE_NOTE_BODY}
  </Alert>
)

export default OverrideInfoNote
